import React from 'react'
import {ParticlesBG,Glow,Content} from './components/'

const Root = () => {
    return (
        <>
            <ParticlesBG />
            <Glow />
            <Content />
        </>
    )
}

export default Root